import * as React from 'react';
import { observer } from 'mobx-react';
import { FieldState } from 'formstate';
import ContractDropdownItem from 'components/ContractDropdownItem';
import { languageStore, ServiceStatusEnum } from 'stores';
import { DropdownOptionInterface } from 'components/Forms/Dropdown';

interface Props {
    fieldState: FieldState<any>,
    editMode?: boolean,
}

@observer class SelectServiceStatus extends React.Component<Props> {

    render() {
        const { fieldState, editMode } = this.props;

        const dropdownOpts = [
            {
                value: ServiceStatusEnum.AGREED,
                name: languageStore.get('agreed')
            },
            {
                value: ServiceStatusEnum.DELETED_OR_HIDDEN,
                name: languageStore.get('deletedOrHidden')
            },
        ] as Array<DropdownOptionInterface>

        return (
            <ContractDropdownItem
                label={languageStore.get('status')}
                id='status'
                placeholderText={languageStore.get('select')}
                fieldState={fieldState}
                options={dropdownOpts}
                skipSort={true}
                type='number'
                editMode={editMode} />
        )
    }

}

export default SelectServiceStatus;